import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { BreadcrumbItem, BreadcrumbProps } from './breadcrumbs.props';

function BreadCrumbItem({ path, title, isLast }: BreadcrumbItem) {
  return (
    <>
      <div className="flex">
        {path && (
          <Link to={path}>
            <span className={!isLast ? 'text-neutral-400' : 'text-neutral-750'}>{title}</span>
          </Link>
        )}
        {!path && <span className={!isLast ? 'text-neutral-400' : 'text-neutral-750'}>{title}</span>}
        {!isLast && <ChevronRight size={18} className={cn('text-base_pg500 mx-[8px] h-full stroke-neutral-400')} />}
      </div>
    </>
  );
}
export default function Breadcrumbs({ breadcrumbs }: BreadcrumbProps) {
  return <div className="flex ">{breadcrumbs.map((crumb, index) => crumb.title && <BreadCrumbItem {...crumb} key={index} />)}</div>;
}
